import React from 'react';
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {Stack, Typography} from "@mui/material";
import {numberFormatter} from "../../../utils/formatters/numberFormatter";

interface LimitesCLFBAdicionalesProps {
    absoluto?: number,
    neto?: number,
}

function LimitesCLFBAdicionales({absoluto, neto}: LimitesCLFBAdicionalesProps): JSX.Element {
    return (
        <TableRow>
            <TableCell>
                <Typography variant="body2">LIMITE AGREGADO</Typography>
            </TableCell>
            <TableCell>
                <Stack direction={'row'}>

                    <>
                        {

                            numberFormatter.toStringWithAmount(neto || null, 'USD ', 0)
                        }
                    </>
                </Stack>
            </TableCell>
            <TableCell>

                <>
                    {

                        numberFormatter.toStringWithAmount(absoluto || null, 'USD ', 0)
                    }
                </>
            </TableCell>
            <TableCell colSpan={8}></TableCell>
        </TableRow>
    );
}

export default LimitesCLFBAdicionales;